import PropTypes from 'prop-types';
import React from 'react';
import {useTranslation} from 'react-i18next';
import {ENTITY_GET_OPTIONS} from '../../../services/albumProvider/albumProviderConstant';
import {getEntityGetOption} from '../../../services/albumProvider/getOptions';
import {Price} from '../../Price/Price';
import {Button} from '../../ui/Button/Button';

export function GetTrackButton(props) {
  const {album, track, onClick, className} = props;
  const {t} = useTranslation();
  const type = getEntityGetOption(album, track);
  if (type === ENTITY_GET_OPTIONS.NOTHING) {
    return null;
  }
  const label = {
    [ENTITY_GET_OPTIONS.GET]: t('mgw.trackPage.getTrack'),
    [ENTITY_GET_OPTIONS.DOWNLOAD]: t('mgw.trackPage.downloadTrack'),
    [ENTITY_GET_OPTIONS.BUY]: (
      <Price price={Number(track.trackPrice)} currency={album.albumCurrency} translationKey="mgw.trackPage.buyTrack" />
    ),
  }[type];

  return (
    <Button className={className} onClick={onClick} dataHook="get-track-button" disabled={album.demo}>
      {label}
    </Button>
  );
}

GetTrackButton.propTypes = {
  className: PropTypes.string,
  t: PropTypes.func,
  album: PropTypes.object,
  track: PropTypes.object,
  onClick: PropTypes.func,
};
